import React from 'react'
import RenderGtmScripts from './render-gtm-scripts'
import { usePathname } from 'next/navigation'
import { MouseflowDataPush } from './mouseflow-data-push'
import RenderZendeskChat from './render-zendesk-chat'
import { useFeatureFlag } from '@dustin-web/microsite-data/src/feature-flags/client'

export const RenderScripts = () => {
  const pathname = usePathname()
  const { enabled: disableScripts } = useFeatureFlag('disable-3rd-party-scripts', true)
  const { enabled: mouseflowTestToggle } = useFeatureFlag('mouseflowtesttoggle')

  if (disableScripts) {
    return null
  }

  return (
    <>
      <RenderGtmScripts />
      {mouseflowTestToggle && <MouseflowDataPush />}
      <RenderZendeskChat path={pathname} />
    </>
  )
}
